import * as React from 'react'
import { ReactElement, useEffect } from 'react'
import { Stack, StackItem } from '@fluentui/react'
import Loading from '../../components/Loading'
import { useRouteMatch } from 'react-router-dom'
import useFileData, { FileData } from '../../hooks/file/useFileData'
import useFilePages, { FilePageProps } from '../../hooks/file/useFilePages'
import ViewFileHeader from '../../components/File/ViewFileHeader'
import ViewFilePivotItems from '../../components/File/ViewFilePivotItems'
import { MessageBar } from '@fluentui/react-components'

// @ts-expect-error("dompurify exports differ from what ts-lint is expecting and cannot see the default export")
import DOMPurify from 'dompurify'
import { AppAction } from '../../config/appConfig'
import { MenuItemKey } from '../../components/MainMenu'
import { useDispatch } from 'react-redux'

export type ViewFileProps = {
    file: FileData
    fileId: string
    activePage: FilePageProps
}

export default function ViewFile(): ReactElement {
    const routeMatch = useRouteMatch<{ fileId: string }>()
    const fileId = routeMatch.params?.fileId

    const dispatch = useDispatch()
    const { activePage } = useFilePages(fileId)
    const { file, getActivePageAction } = useFileData(fileId, activePage)

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Files] })
    }, [])

    if (!file.current.loaded || !activePage) {
        return <Loading />
    }

    return (
        <Stack tokens={{ childrenGap: 's1' }}>
            <ViewFileHeader file={file} fileId={fileId} activePage={activePage} />
            {file.current.data.notification && (
                <MessageBar intent="warning" layout={'multiline'}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(file.current.data.notification)?.replaceAll('\n', '<br/>'),
                        }}
                    ></div>
                </MessageBar>
            )}
            <ViewFilePivotItems file={file} fileId={fileId} activePage={activePage} />
            <StackItem>{activePage?.content(file, getActivePageAction())}</StackItem>
        </Stack>
    )
}
